import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './styles.scss';

interface Props {
  title: string;
  className?: string;
  modeToggle?: ReactNode;
}

export const SectionTitle = ({ title, className, modeToggle }: Props) => (
  <div className={cn(styles.sectionTitle, className)}>
    <h3>{title}</h3>
    {modeToggle}
  </div>
);
